import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { SessionFiles } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  fileName: z.string().min(1),
  filePath: z.string().min(1),
  content: z.string().optional(),
  language: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  file: Selectable<SessionFiles>;
};

export const createFile = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/files/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorText = await result.text();
    let errorMessage = 'File creation failed';
    try {
      const errorObject = superjson.parse<{ error: string; details?: string }>(errorText);
      errorMessage = errorObject.details
        ? `${errorObject.error}: ${errorObject.details}`
        : errorObject.error;
    } catch {
      errorMessage = `HTTP ${result.status}: ${errorText}`;
    }
    throw new Error(errorMessage);
  }
  return superjson.parse<OutputType>(await result.text());
};
